import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class LoaderService {

  public isLoading = new BehaviorSubject(false);

  constructor() { }

  public get Loading() {
    return this.isLoading.asObservable()
  }
}
